import { useEffect, useRef, useState } from 'react';

export interface DeviceChoice {
  audioInput: string | undefined;
  audioOutput: string | undefined;
  videoInput: string | undefined;
}

export function PreJoin({ onReady, onCancel }: { onReady: (choice: DeviceChoice) => void; onCancel: () => void }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const streamRef = useRef<MediaStream | null>(null);
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [choice, setChoice] = useState<DeviceChoice>({ audioInput: undefined, audioOutput: undefined, videoInput: undefined });
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    void (async () => {
      let stream: MediaStream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: { width: 640, height: 360 } });
      } catch (reason) {
        setError(`Камера недоступна; можно продолжить аудиозвонок. ${reason instanceof Error ? reason.message : ''}`);
        stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
      }
      if (!active) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }
        streamRef.current = stream;
        if (videoRef.current) videoRef.current.srcObject = stream;
        const available = await navigator.mediaDevices.enumerateDevices();
        setDevices(available);
        setChoice({
          audioInput: stream.getAudioTracks()[0]?.getSettings().deviceId,
          audioOutput: undefined,
          videoInput: stream.getVideoTracks()[0]?.getSettings().deviceId
        });
    })().catch((reason: unknown) => setError(reason instanceof Error ? reason.message : 'Нет доступа к микрофону'));
    return () => {
      active = false;
      streamRef.current?.getTracks().forEach((track) => track.stop());
    };
  }, []);

  function finish() {
    streamRef.current?.getTracks().forEach((track) => track.stop());
    onReady(choice);
  }

  const select = (kind: MediaDeviceKind, label: string, value: string | undefined, update: (value: string) => void) =>
    <label>{label}<select value={value ?? ''} onChange={(event) => update(event.target.value)}>
      <option value="">По умолчанию</option>
      {devices.filter((device) => device.kind === kind).map((device, index) =>
        <option key={device.deviceId} value={device.deviceId}>{device.label || `${label} ${index + 1}`}</option>)}
    </select></label>;

  return <section className="prejoin card">
    <h2>Проверка перед звонком</h2>
    <video ref={videoRef} autoPlay muted playsInline />
    {error && <p className="error">{error}</p>}
    <div className="device-grid">
      {select('audioinput', 'Микрофон', choice.audioInput, (audioInput) => setChoice({ ...choice, audioInput }))}
      {select('videoinput', 'Камера', choice.videoInput, (videoInput) => setChoice({ ...choice, videoInput }))}
      {select('audiooutput', 'Динамик', choice.audioOutput, (audioOutput) => setChoice({ ...choice, audioOutput }))}
    </div>
    <div className="row"><button onClick={onCancel}>Назад</button><button className="primary" onClick={finish}>Продолжить</button></div>
  </section>;
}
